import { useEffect, useState } from 'react'
import { NavLink, SetURLSearchParams } from 'react-router-dom'
import { Button } from '../../../components/button'
import { format } from 'date-fns'

import Icon from '../../../components/icon'
import Dropdown from '../../../components/inputs/dropdown'
import { TableComponent } from '../../../components/table'
import { formatCurrency } from '../../../helpers'
import { useModalControl } from '../../../hooks/useModalControl'
import { useGetSettlementsReportQuery } from '../../../redux-toolkits/reports/reports.slice'
import { DashboardReportParams } from '../../../redux-toolkits/reports/reports.type'
import { ReportQueryProps } from '../../../types/types'
import { ExportDataModal } from '../../../components/modal/app_modals/exportDataModal'

export const PerformanceTable = ({
  mainDashQuery,
  searchParams,
  setSearchParams,
}: {
  mainDashQuery: DashboardReportParams
  searchParams: URLSearchParams
  setSearchParams: SetURLSearchParams
}) => {
  const [query, setQuery] = useState<ReportQueryProps>({
    filter: (searchParams.get('filter') as any) ?? 'today',
    startDate: undefined,
    endDate: undefined,
    page: Number(searchParams.get('page')),
    limit: 20,
    sort: 'desc',
  })

  const { modal, modalOpen, setModalOpen, handleModalClose, handleModalOpen } =
    useModalControl()

  const { data: respData, isFetching: fetchingData } =
    useGetSettlementsReportQuery(
      {
        ...query,
        ...mainDashQuery,
      },
      {
        refetchOnMountOrArgChange: true,
      },
    )

  useEffect(() => {
    setQuery({ ...query, page: Number(searchParams.get('page')) })
  }, [searchParams.get('page')])

  return (
    <>
      <div className="flex-wrap flex items-center gap-4 justify-between">
        <div className="flex-1 min-w-full md:min-w-fit" />

        <Button
          label="Export"
          onClick={async () => {
            handleModalOpen('exportDataModal')
          }}
          // loading={exportingReport}
          primary
          className="w-full max-w-[129px]"
        />

        <Dropdown
          className="!max-h-[58px]"
          menuButton={
            <button type="button" className="rotate-90">
              <Icon width={58} height={56} id="verticalDots" />
            </button>
          }
          menuItems={[
            {
              name: 'Total Sales: low to high',
              value: 'asc',
              onClick: () => {
                setQuery({
                  ...query,
                  sort: 'asc',
                })
              },
            },
            {
              name: 'Total Sales: high to low',
              value: 'desc',
              onClick: () => {
                setQuery({
                  ...query,
                  sort: 'desc',
                })
              },
            },
          ]}
          menuItemClassName="border-b-0"
          menuClassName="!w-[200px]"
        />
      </div>

      <div className="w-full overflow-x-scroll">
        <TableComponent
          headers={[
            'Account Name',
            'Account Number',
            'Bank Name',
            'Amount (₦)',
            'Date',
          ]}
          rows={
            respData?.data?.docs?.map((summary, idx) => {
              return {
                id: idx,
                content: [
                  <NavLink
                    to={`/dashboard/${summary._id}`}
                    className={`flex gap-2 items-center`}
                    key={`product-${summary._id}-name`}
                  >
                    {summary.accountName}
                  </NavLink>,
                  summary.accountNumber,
                  summary.bankName,
                  formatCurrency(summary.amount),
                  `${format(summary.createdAt, 'dd/MM/yyyy h:mma')}`,
                ],
              }
            }) ?? []
          }
          isEmpty={[0, undefined].includes(respData?.data?.docs?.length)}
          loading={fetchingData}
          currentPage={Number(query.page)}
          totalDataCount={respData?.data?.total}
          pageLimit={Number(query.limit!)}
          onPageChange={(page) => {
            setSearchParams({
              ...Object.fromEntries(searchParams),
              page: encodeURIComponent(page),
            })
            setQuery({ ...query, page })
          }}
        />
      </div>

      <ExportDataModal
        open={modalOpen && modal === 'exportDataModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={() => {
          handleModalClose()
        }}
        extraValues={{}}
        title="Export"
      />
    </>
  )
}
